import { Group, Popover, Tooltip, useMantineColorScheme } from '@mantine/core';
import { useCurrentEditor } from '@tiptap/react';
import React, { FC, useContext, useState } from 'react';
// import EmojiPicker, { IEmojiData } from 'emoji-picker-react';
import { IconHash, IconMoodWink2 } from '@tabler/icons';
import EmojiPicker, { Theme } from 'emoji-picker-react';
import { WindowContext } from '../../../Service/Context/WindowContext';
import ActionIconWithoutFocus from '../../../Atoms/ActionIconWithoutFocus';

const BaseToolbar: FC<{ includePlaceholders?: boolean }> = ({ includePlaceholders = true }) => {
  const { editor } = useCurrentEditor();
  const [opened, setOpened] = useState(false);
  const { md } = useContext(WindowContext);
  const { colorScheme } = useMantineColorScheme();

  const onEmojiClick = (data: any) => {
    if (editor) {
      editor.commands.insertContent(data.emoji);
      setOpened(false);
    }
  };

  const onHashClicked = () => {
    if (editor) {
      editor.commands.insertContent('#');
    }
  };

  if (!editor) {
    return null;
  }

  return (
    <Group spacing={0} p="xs">
      {!md && (
        <Popover opened={opened} onChange={setOpened} position="top" returnFocus>
          <Popover.Target>
            <Tooltip openDelay={300} withArrow transition="slide-up" label="Emoji">
              <div>
                <ActionIconWithoutFocus variant="subtle" onClick={() => setOpened((o) => !o)}>
                  <IconMoodWink2 size={20} />
                </ActionIconWithoutFocus>
              </div>
            </Tooltip>
          </Popover.Target>
          <Popover.Dropdown p={0} sx={{ border: 'none' }}>
            <EmojiPicker onEmojiClick={onEmojiClick} searchPlaceHolder="Suchen" theme={colorScheme as Theme} />
          </Popover.Dropdown>
        </Popover>
      )}
      {includePlaceholders && (
        <Tooltip openDelay={300} withArrow transition="slide-up" label="Platzhalter einfügen">
          <div>
            <ActionIconWithoutFocus onClick={onHashClicked}>
              <IconHash size={20} />
            </ActionIconWithoutFocus>
          </div>
        </Tooltip>
      )}
    </Group>
  );
};

export default BaseToolbar;
